<template>
  <RouterLink
    v-slot="{ isActive }"
    :to="{ name: $route.meta.route_name, params: { id: dashboard.id } }"
  >
    <div
      :class="[
        isActive
          ? 'border-blue-500 text-blue-600 dark:border-blue-400'
          : 'border-transparent text-gray-600'
      ]"
      class="group relative flex flex-row items-center gap-2 border-b-2 px-2 py-1 text-sm font-medium hover:border-blue-500 hover:text-blue-600 dark:bg-slate-700 dark:text-slate-300"
    >
      <FontAwesomeIcon :icon="['fal', getIcon]" />
      <FontAwesomeIcon
        v-if="isLoading"
        :icon="['fal', icon ?? 'spinner-third']"
        class="text-primary animate-spin"
      />
      <span class="capitalize-first cursor-pointer truncate py-0.5">
        {{ dashboard.name[$i18n.locale] }}
      </span>
    </div>
  </RouterLink>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import DashboardTypes from '@/assets/enums/dashboard/DashboardTypes'

export default {
  name: 'TabTemplateItem',
  components: { FontAwesomeIcon },
  props: {
    dashboard: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['action'],
  data() {
    return {
      editLabelMode: false,
      isLoading: false
    }
  },
  computed: {
    analyticsGroupIcon() {
      const iconByGroup = {
        dossier: 'book',
        invoicing: 'receipt',
        event: 'calendar',
        invoice_item: 'sitemap',
      }
      return iconByGroup[this.dashboard.group] ?? 'chart-bar'
    },
    getIcon() {
      switch (this.dashboard.type) {
        case DashboardTypes.AGENDA:
          return 'calendar-day'
        case DashboardTypes.ANALYTICS:
          return this.analyticsGroupIcon
        case DashboardTypes.STATISTICS:
          return 'chart-bar'
        case DashboardTypes.INVOICE:
        case DashboardTypes.PURCHASE_ORDER:
        case DashboardTypes.QUOTE:
        case DashboardTypes.CREDIT_NOTE:
          return 'euro-sign'
        case DashboardTypes.DASHBOARD:
          return 'table'
        case DashboardTypes.SUPPLIER_ORDER:
          return 'truck'
        default:
          return 'house'
      }
    }
  }
}
</script>
